<script lang="ts">
    import Dummy from '../../../shared/Dummy.svelte';
    import { Const } from '../../../../stores/Const.js';
    import Duration from '../../../shared/Duration.svelte';
    import Distance from '../../../shared/Distance.svelte';
    import { Assignment } from '../Assignment.js';
    import WarningColor from '../../../shared/WarningColor.svelte';
    import { RouteInfoUtils } from '../PageDeliveries2/RouteSummaryApp/RouteInfoUtils';
    import RouteCost from './RouteCost.svelte';

    export let assignment: Assignment;
    export let color: string| null = null;

    let routeDataWrapper = Dummy;
    let cost: number | null = null;
    let costDetails: any = {};

    $: {
        if (assignment.isRouteModifiedAfterDownload() && false) {
            routeDataWrapper = WarningColor;
        } else {
            routeDataWrapper = Dummy;
        }
    }

    $: {
        cost = RouteInfoUtils.getCostByDistanceAndQuantity(
            assignment.getRsa().getBaseRoute().distanceMeters,
            assignment.getRsa().getBaseRoute().quantity,
            assignment.getRsa().getBaseRoute().durationSeconds,
            assignment.getRsa().getBaseRoute().tolls,
            assignment.getVehicle(),
            costDetails
        );
    }
</script>

<svelte:component this={routeDataWrapper}>
    <div class="route_info_inner" style="color: {color ? color : 'inherit'};">
        <div class="distance">
            {#if assignment.getRsa().isBaseRouteComparable() && !assignment.isRouteInCalculation()}
                <span
                    data-desc="distance-if"
                    data-estimated={assignment.getRsa().getBaseRoute().isEstimated}
                >
                    <Distance
                        meters={assignment.getRsa().getBaseRoute().distanceMeters}
                        compare={assignment.getRsa().getCurrentRoute().distanceMeters}
                        estimation={assignment.getRsa().getBaseRoute().isEstimated}
                        noColors={assignment.isRouteInvalid()}
                        flexDirection="column"
                        bold={false}
                    />
                </span>
            {:else}
                <span
                    data-desc="distance-else"
                    data-estimated={assignment.getRsa().getBaseRoute().isEstimated}
                >
                    <Distance
                        meters={assignment.getRsa().getBaseRoute().distanceMeters}
                        estimation={assignment.getRsa().getBaseRoute().isEstimated}
                        flexDirection="column"
                        bold={false}
                    />
                </span>
            {/if}
        </div>
        <div class="vertical-separator">|</div>
        <div class="duration">
            {#if assignment.getRsa().isBaseRouteComparable() && !assignment.isRouteInCalculation()}
                <Duration
                    seconds={assignment.getRsa().getBaseRoute().durationSeconds}
                    compare={assignment.getRsa().getCurrentRoute().durationSeconds}
                    estimation={assignment.getRsa().getBaseRoute().isEstimated}
                    showExclamation={false}
                    warningAbove={routeDataWrapper !== Dummy
                        ? null
                        : Const.WORK_DAY_DURATION_SECONDS}
                    errorAbove={routeDataWrapper !== Dummy ? null : Const.WORK_DAY_DURATION_SECONDS}
                    noColors={assignment.isRouteInvalid()}
                    flexDirection="column"
                    displayFormat="time"
                    bold={false}
                />
            {:else}
                <Duration
                    seconds={assignment.getRsa().getBaseRoute().durationSeconds}
                    estimation={assignment.getRsa().getBaseRoute().isEstimated}
                    showExclamation={false}
                    warningAbove={routeDataWrapper !== Dummy
                        ? null
                        : Const.WORK_DAY_DURATION_SECONDS}
                    errorAbove={routeDataWrapper !== Dummy ? null : Const.WORK_DAY_DURATION_SECONDS}
                    flexDirection="column"
                    displayFormat="time"
                    bold={false}
                />
            {/if}
        </div>
        <div class="vertical-separator">|</div>
        <div class="route-cost">
            <RouteCost
                {cost}
                currency={RouteInfoUtils.getCurrency()}
                estimation={assignment.getRsa().getBaseRoute().isEstimated}
                details={costDetails}
            />
        </div>
    </div>
</svelte:component>

<style>
    .route_info_inner {
        display: flex;
        justify-content: center;
        /*width: 100%;*/
        font-size: 12px;
        align-items: center;
        margin-bottom: -1px;
    }
    .route_info_inner .distance {
        display: flex;
        flex: 1 1 40%;
        justify-content: center;
        padding: 0 2px;
    }
    .route_info_inner .duration {
        display: flex;
        flex: 1 0 20%;
        justify-content: center;
        padding: 0 2px;
    }
    .route_info_inner .route-cost {
        display: flex;
        flex: 1 1 40%;
        justify-content: center;
        padding: 0 2px;
    }
    .vertical-separator {
        font-weight: 200;
        margin: 0 3px;
        opacity: 0.3;
    }
</style>
